import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Home from "./components/Home";
import Services from "./components/Services";
import About from "./components/About";
import Contact from "./components/Contact";

const App = () => {
  return (
    <Router>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
};

function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      // If no hash, scroll to top on route change
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      return;
    }

    // Remove the leading '#' from hash
    const id = hash.replace('#', '');
    // Give the page a moment to render the target element
    const scrollToElement = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    // If same pathname, try immediately; otherwise wait a short tick after navigation
    setTimeout(scrollToElement, 50);
  }, [hash, pathname]);

  return null;
}

export default App;
